module.exports = __webpack_public_path__ + "static/media/rombo.3b363ea3.svg";